module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point1_1-bea1889692d6e2edc4c0bbb3f9ff1db6.jpg";